interface FileThumbnailProps {
  file: any;
  mimeType: string;
  placeholder: string;
  isSvgOrAi: boolean;
  imageClassName: string;
  placeholderClassName: string;
}

const FileThumbnail = ({
  file,
  mimeType,
  placeholder,
  isSvgOrAi,
  imageClassName,
  placeholderClassName,
}: FileThumbnailProps) =>
  file.base64 ? (
    <img
      src={`data:${mimeType};base64,${file.base64}`}
      alt={file.file}
      className={`${isSvgOrAi ? "object-scale-down p-2" : process.env.REACT_APP_IMAGE_FILL} ${imageClassName}`}
    />
  ) : (
    <img src={placeholder} alt={file.file} className={placeholderClassName} />
  );

export default FileThumbnail;
